import * as React from 'react'
import { Actions as WBActions } from '../modules-drivers/wb'
import { Actions as CMActions } from '../modules-drivers/cm'
import { Actions as TPDDActions } from '../modules-drivers/tpdd'
import { Actions as GDPRActions } from '../modules-drivers/gdpr'
const Drivers = [
    {
        name: 'wb',
        path: () => {
            return new Promise((resolve) => {
                resolve({
                    Actions: WBActions
                })
            })
        }
    },
    {
        name: 'cm',
        path: () => {
            return new Promise((resolve) => {
                resolve({
                    Actions: CMActions
                })
            })
        }
    },
    {
        name: 'tp',
        path: () => {
            return new Promise((resolve) => {
                resolve({
                    Actions: TPDDActions
                })
            })
        }
    },
    {
        name: 'gd',
        path: () => {
            return new Promise((resolve) => {
                resolve({
                    Actions: GDPRActions
                })
            })
        }
    }
]

export default Drivers
